import React, { useState} from 'react';
import { connect } from "react-redux";
import { daysName, monthNames , daysNameEvaluation } from "../../../actions/utility"
import {submitEvaluationReport} from "../../../actions/tutorFeedActions"
import "./Evaluations.css";
import AudioFeedbackDesign from './AudioFeedbackDesign';
import DemoStudentEvaluation from './DemoStudentEvaluation';
const Evaluation = (props) => {
    const [evaluationData, setevaluationData] = useState([]);
    const [programNameState, setprogramNameState] = useState("");
    const [todaysDate, settodaysDate] = useState(new Date());
    const [alreadySubmitted, setalreadySubmitted] = useState(true);
    const [loggedUserId, setloggedUserId] = useState("");
    const [clientId, setclientId] = useState("");
    const [snackbarMessage, setsnackbarMessage] = useState("");
    const [submitLoading, setsubmitLoading] = useState(false);
    const [snackbar, setsnackbar] = useState(false);
    const [snackColor, setsnackColor] = useState("");
    const [disableButton, setdisableButton] = useState(false);
    
    if (props.programNameState.programName !== programNameState) {
        const { programNameState , attendanceData } = props;
        debugger;
        localStorage.setItem("programName", programNameState);
        var LoginData = JSON.parse(localStorage.getItem("loginData"))
        setloggedUserId(LoginData.user.id);
        setclientId(LoginData.user.client_id);
        setprogramNameState(programNameState.programName);
        let TeacherStudent = LoginData.teacher_students;

        function ObjectLength( object ) {
            var length = 0;
            for( var key in object ) {
                if( object.hasOwnProperty(key) ) {
                    ++length;
                }
            }
            return length;
        };

        if (typeof TeacherStudent[programNameState.programName] != "undefined") {
            debugger;
            let mapOver = [];
            var countNull = 0;
            var a = TeacherStudent[programNameState.programName].map((item, index) => {
                
                //Conditon to check Evaluation Submitted or Not
                if(attendanceData.evaluation_data[programNameState.slotProgram][item.student_id] == null){
                    debugger;
                    countNull++;
                }

                var objectLength = ObjectLength(attendanceData.evaluation_data[programNameState.slotProgram]);

                if(countNull == objectLength){
                    debugger;
                    setalreadySubmitted(false);
                }
                else{
                    debugger;
                    setalreadySubmitted(true);
                }
                //Ends Here

                //Conditions to render Evaluation Data from Redux Store
                if(attendanceData.teacher_students[programNameState.slotProgram][item.student_id].attendance_status == 0){
                    mapOver.push({
                                    isPresent: 0,
                                    id: item.student_id,
                                    name: item.user_name,
                                    image: item.image,
                                    onTime: "",
                                    attentive: "",
                                    homeworkCompletion: "",
                                    classworkCompletion: "",
                                    is_expired: item.is_expired,
                                    is_scheduled_demo: item.is_scheduled_demo,
                                    course_id: item.course_id
                                })
                }
                else if(attendanceData.teacher_students[programNameState.slotProgram][item.student_id].attendance_status == 1 && attendanceData.evaluation_data[programNameState.slotProgram][item.student_id] != null ){
                    mapOver.push({
                                     isPresent: attendanceData.evaluation_data[programNameState.slotProgram][item.student_id].attendance_status,
                                     id: item.student_id,
                                     name: item.user_name,
                                     image: item.image,
                                     onTime: attendanceData.evaluation_data[programNameState.slotProgram][item.student_id].onTime,
                                     attentive: attendanceData.evaluation_data[programNameState.slotProgram][item.student_id].attentive,
                                     homeworkCompletion: attendanceData.evaluation_data[programNameState.slotProgram][item.student_id].homeworkCompletion,
                                     classworkCompletion: attendanceData.evaluation_data[programNameState.slotProgram][item.student_id].classworkCompletion,
                                     is_expired: item.is_expired,
                                     is_scheduled_demo: item.is_scheduled_demo,
                                     course_id: item.course_id
                                 })
                }
                else if(attendanceData.teacher_students[programNameState.slotProgram][item.student_id].attendance_status == 1 && attendanceData.evaluation_data[programNameState.slotProgram][item.student_id] == null){
                    mapOver.push({
                        isPresent: 1,
                        id: item.student_id,
                        name: item.user_name,
                        image: item.image,
                        onTime: "",
                        attentive: "",
                        homeworkCompletion: "",
                        classworkCompletion: "",
                        is_expired: item.is_expired,
                        is_scheduled_demo: item.is_scheduled_demo,
                        course_id: item.course_id
                    })
                }
                // if(typeof attendanceData.evaluation_data[programNameState.program] != "undefined" && typeof attendanceData.evaluation_data[programNameState.program][item.student_id] != "undefined"){
                //     debugger;
                //     if(attendanceData.evaluation_data[programNameState.program][item.student_id] != null){
                //         mapOver.push({
                //             isPresent: attendanceData.evaluation_data[programNameState.program][item.student_id].attendance_status,
                //             id: item.student_id,
                //             name: item.user_name,
                //             image: item.image,
                //             onTime: attendanceData.evaluation_data[programNameState.program][item.student_id].onTime,
                //             attentive: attendanceData.evaluation_data[programNameState.program][item.student_id].attentive,
                //             homeworkCompletion: attendanceData.evaluation_data[programNameState.program][item.student_id].homeworkCompletion,
                //             classworkCompletion: attendanceData.evaluation_data[programNameState.program][item.student_id].classworkCompletion
                //         })
                //         debugger;
                //     }
                //     else{
                //         mapOver.push({
                //             isPresent: 0,
                //             id: item.student_id,
                //             name: item.user_name,
                //             image: item.image,
                //             onTime: "",
                //             attentive: "",
                //             homeworkCompletion: "",
                //             classworkCompletion: ""
                //         })
                //         debugger;
                //     }
                // }
                // else{
                //     mapOver.push({
                //         isPresent: 0,
                //         id: item.student_id,
                //         name: item.user_name,
                //         image: item.image,
                //         onTime: "",
                //         attentive: "",
                //         homeworkCompletion: "",
                //         classworkCompletion: ""
                //     })
                //     debugger;
                // }
                // if(typeof attendanceData.teacher_students[programNameState.program] != "undefined" && typeof attendanceData.teacher_students[programNameState.program][item.student_id] != "undefined"){
                //     mapOver.push({
                //         isPresent: attendanceData.teacher_students[programNameState.program][item.student_id].attendance_status,
                //         id: item.student_id,
                //         name: item.user_name,
                //         image: item.image,
                //         onTime: "",
                //         attentive: "",
                //         homeworkCompletion: "",
                //         classworkCompletion: ""
                //     })
                //     debugger;
                // }
                // else{
                //     mapOver.push({
                //         isPresent: 0,
                //         id: item.student_id,
                //         name: item.user_name,
                //         image: item.image,
                //         onTime: "",
                //         attentive: "",
                //         homeworkCompletion: "",
                //         classworkCompletion: ""
                //     })
                //     debugger;
                // }
            })
            console.log("MAP OVER", mapOver);
            setevaluationData(mapOver);

        }
    }
    const changeState = (studentId, status, columnName) => {
        evaluationData.map((item, index) => {
            if (studentId == item.id) {
                if (columnName == "onTime" && status == true) {
                    item.onTime = 1
                }
                else if (columnName == "onTime" && status == false) {
                    item.onTime = 0
                }
                else if (columnName == "attentive" && status == true) {
                    item.attentive = 1
                }
                else if (columnName == "attentive" && status == false) {
                    item.attentive = 0
                }
                else if (columnName == "homeworkCompletion" && status == true) {
                    item.homeworkCompletion = 1
                }
                else if (columnName == "homeworkCompletion" && status == false) {
                    item.homeworkCompletion = 0
                }
                else if (columnName == "classworkCompletion" && status == true) {
                    item.classworkCompletion = 1
                }
                else if (columnName == "classworkCompletion" && status == false) {
                    item.classworkCompletion = 0
                }
            }
        })
        setevaluationData([...evaluationData])
    }

    const getCurrentDate = () => {
        console.log("Today's Date: " , todaysDate);
        if(typeof todaysDate === 'object' && typeof todaysDate.getFullYear === 'function' && typeof todaysDate.getFullYear().toString() === 'string'){
            var year = todaysDate.getFullYear().toString().substr(-2)
            return (
                <label>
                    {daysNameEvaluation[todaysDate.getDay()].slice(0, 3)} {todaysDate.getDate()} {monthNames[todaysDate.getMonth()].slice(0, 3)} '{year}
                </label>
            )
        }
        else{
            return (
                <label>
                    Day - Date - Month - Year
                </label>
            )
        }
       
    }
    console.log("EVALUATION DATA", evaluationData);
    const submitEvaluation = () => {
        setsubmitLoading(true);
        setdisableButton(true);
        props.submitEvaluationReport(clientId , loggedUserId, props.programNameState.program,props.programNameState.programName , evaluationData, props.programNameState.slotId)
        .then(success => {
            debugger;
            if (success.data.status == "success") {
                setsnackbarMessage("Evaluation Added Successfully");
                setsnackbar(true);
                setsubmitLoading(false);
                setTimeout(() => {
                    props.history.push("/Teacherdashboard");
                    window.location.reload();
                    setsnackbar(false);
                    setsnackColor("#01ac8a");
                }, 2000);
              }
        })
        .catch(err => {
            setsnackbarMessage("Evaluation Already Submitted");
            setsnackbar(true);
            setsnackColor("#ed2525")
            setTimeout(() => {
                props.history.push("/Teacherdashboard");
                window.location.reload();
                setsnackbar(false);
            }, 2000);
            debugger;
        })
    }
    const check = () => {
        const validation = evaluationData.every(item => item.attentive == "" && item.classworkCompletion == "");
        console.log("Validate" , validation);
    }
    return (
        <div className="row">
        <div className="col-md-9" id="evaluationDiv">
            <div className={snackbar ? "show" : ""} id="snackbar" style={{ backgroundColor: snackColor }}>{snackbarMessage}</div>
            <div class="card shadow-sm">
                <div class="card-body">
                    <h5 class="card-title">{programNameState}</h5>
                    {/* <button onClick={check}>Validate</button> */}
                    <div className="row">
                        <div className="col-md-6">
                            <label className="text-muted">Class Attendance And Participation Evaluation</label>
                        </div>
                        <div className="col-md-6 text-right">
                            {getCurrentDate()}
                        </div>
                    </div>
                    <br />
                    <br />
                    <br />
                    {alreadySubmitted ? <label className="text-success small">*Evaluation already submitted for today</label> : null}
                    <div className="table-responsive">
                        <table class="table" style={alreadySubmitted ? {pointerEvents: "none"} : null}>
                            <tr className="tableHeaderP">
                                <th className=""></th>
                                <th className="addExtrawidth">On Time</th>
                                <th className="addExtrawidth">Attentive</th>
                                <th className="">Homework <br/> Completion</th>
                                <th className="">Classwork <br/> Completion</th>
                            </tr>
                            <tbody>
                                {evaluationData.length > 0 ? evaluationData.map((item, index) => (
                                    <tr key={index} className={item.isPresent == 0 ? "disableFields" : null}>
                                        <th className="">{item.image !== null ? <img src={`https://lincolnmethod.s3.us-east-1.amazonaws.com/profileImages/${item.image}`} alt="Avatar" className="avatarStudent" /> : <img src={require("../../../public/images/emptyuserphoto.png")} alt="Avatar" className="avatarStudent" />}
                                            <label className="avatarMargin">{item.name}  </label>
                                            {/* <span className="" style={{ color: "orange" }}>
                                                <i
                                                className="fas fa-star"
                                                style={{ fontSize: 16 }}
                                                ></i>
                                            </span>  */}
                                        </th>
                                        <td className="addExtrawidth"> <div className="iconsCss"> <label onClick={() => changeState(item.id, true, "onTime")}> <i className={item.onTime == true ? "smileSelect far fa-grin" : "iconsCss far fa-grin"}></i></label> <label onClick={() => changeState(item.id, false, "onTime")}> <i className={item.onTime !== "" ? item.onTime == false ? "far fa-meh sadSelect" : "far fa-meh" : "far fa-meh"}></i></label></div></td>
                                        <td className="addExtrawidth"> <div className="iconsCss"> <label onClick={() => changeState(item.id, true, "attentive")}> <i className={item.attentive == true ? "smileSelect far fa-grin" : "iconsCss far fa-grin"}></i></label> <label onClick={() => changeState(item.id, false, "attentive")}> <i className={item.attentive !== "" ? item.attentive == false ? "far fa-meh sadSelect" : "far fa-meh" : "far fa-meh"}></i></label></div></td>
                                        <td className=""> <div className="iconsCss"> <label onClick={() => changeState(item.id, true, "homeworkCompletion")}> <i className={item.homeworkCompletion == true ? "smileSelect far fa-grin" : "iconsCss far fa-grin"}></i></label> <label onClick={() => changeState(item.id, false, "homeworkCompletion")}> <i className={item.homeworkCompletion !== "" ? item.homeworkCompletion == false ? "far fa-meh sadSelect" : "far fa-meh" : "far fa-meh"}></i></label></div></td>
                                        <td className=""> <div className="iconsCss"> <label onClick={() => changeState(item.id, true, "classworkCompletion")}> <i className={item.classworkCompletion == true ? "smileSelect far fa-grin" : "iconsCss far fa-grin"}></i></label> <label onClick={() => changeState(item.id, false, "classworkCompletion")}> <i className={item.classworkCompletion !== "" ? item.classworkCompletion == false ? "far fa-meh sadSelect" : "far fa-meh" : "far fa-meh"}></i></label></div></td>
                                        {/* <td className="col-3"> <div className="iconsCss"> <label className={item.onTime == true ? "smileSelect" : "iconsCss"} onClick={() => changeState(item.id, true, "onTime")}> <i className="far fa-grin"></i></label><label className="countOnTime">29</label> <label onClick={() => changeState(item.id, false, "onTime")}> <i className={item.onTime !== "" ? item.onTime == false ? "far fa-meh sadSelect" : "far fa-meh" : "far fa-meh"}></i></label><label className="countOfNotTime">19</label></div></td>
                                        <td className="col-3"> <div className="iconsCss"> <label className={item.attentive == true ? "smileSelect" : "iconsCss"} onClick={() => changeState(item.id, true, "attentive")}> <i className="far fa-grin"></i></label><label className="countOnTime">29</label> <label onClick={() => changeState(item.id, false, "attentive")}> <i className={item.attentive !== "" ? item.attentive == false ? "far fa-meh sadSelect" : "far fa-meh" : "far fa-meh"}></i></label><label className="countOfNotTime">19</label></div></td>
                                        <td className="col-3"> <div className="iconsCss"> <label className={item.workCompletion == true ? "smileSelect" : "iconsCss"} onClick={() => changeState(item.id, true, "workCompletion")}> <i className="far fa-grin"></i></label><label className="countOnTime">29</label> <label onClick={() => changeState(item.id, false, "workCompletion")}> <i className={item.workCompletion !== "" ? item.workCompletion == false ? "far fa-meh sadSelect" : "far fa-meh" : "far fa-meh"}></i></label><label className="countOfNotTime">19</label></div></td> */}
                                    </tr>
                                )) : null}
                            </tbody>
                        </table>
                    </div>
                    <br/>
                    {!alreadySubmitted ?
                    <div className="row">
                        <div className="col-md-12 text-right"> 
                    <div>
                        <button className="btn btn-success btn-sm" onClick={!disableButton ? submitEvaluation : null}>Share with Parents <i className="fas fa-paper-plane"></i></button>
                    </div>
                    </div>
                    {submitLoading ? 
                    <div className="col-md-1">
                       <div className="text-right">
                            <div class="spinner-border" role="status">
                                <span class="sr-only">Loading...</span>
                        </div>
                    </div> 
                </div> : null}
                    </div>
           : null}
                {/* <AudioFeedbackDesign /> */}
                <DemoStudentEvaluation clientId={clientId} programId={props.programNameState.program} teacherId={loggedUserId} evaluationData={evaluationData} />
                </div>
            </div>
        </div>
        </div>
        );
}

function mapStateToProps(state) {
    return {
        programNameState: state.feedTutorRed.programName,
        attendanceData: state.feedTutorRed.attendanceData
    };
}
export default connect(mapStateToProps, {submitEvaluationReport})(Evaluation);